import {message, Spin} from 'antd'
import React from 'react'
import {instance as plantsService} from '../../services/PlantsService'
import {useNavigate} from 'react-router-dom'
import {PlantsTableProps} from '../plantsTable/PlantsTable'
import {useIntl} from 'react-intl'
import './plantsGallery.less'
import {useAsyncValue} from '../../hooks/useAsyncValue'
import {useInfiniteScroll} from '../../hooks/useInfiniteScroll'
import {PlantModal} from '../plantForm/PlantModal'
import {PlantCard} from './PlantCard'

export function PlantsGallery({
  plants,
  getPlantLink,
  parentRoute,
  loadMore,
  hasMore,
  isLoadingMore,
}: PlantsTableProps) {
  const [messageApi, contextHolder] = message.useMessage()
  const intl = useIntl()
  const navigate = useNavigate()

  const sentinelRef = useInfiniteScroll<HTMLDivElement>({loadMore, hasMore, items: plants})

  const {
    value: plantTitlePhotos,
    isLoading: plantPhotoLoading,
    error,
  } = useAsyncValue(
    [],
    async () => {
      return await Promise.all(
        plants.map(async (plant) => ({
          plantId: plant.id,
          plantTitlePhoto: await plantsService.getTitlePlantPhoto(
            plant.titlePhotoName,
            plant.photos[0]
          ),
        }))
      )
    },
    [plants]
  )

  return (
    <div>
      {contextHolder}
      {/* <AntdButton
        type="link"
        style={{float: 'right'}}
        onClick={() => {
          navigate(`${parentRoute}/plants/new`)
        }}
      >
        {intl.formatMessage({id: 'addPlant'})}...
      </AntdButton> */}

      <div className="plants__list">
        {plants.map((plant, index) => (
          <a
            key={index}
            className="plants__list__link"
            onClick={() => {
              //setIsOpenForm(true)
              //setcurrentPlant(plant)
              navigate(getPlantLink(plant))
            }}
          >
            <PlantCard
              photo={plantTitlePhotos[index]?.plantTitlePhoto}
              sun={0}
              watering={0}
              name={plant.name}
              description={
                plant.plantBaseId
                  ? `${plant.fields['Общераспространенное название']} ${
                      plant.fields['Сорт_eng'] || plant.fields['Сорт_ru']
                        ? ` ${plant.fields['Сорт_eng']}`
                          ? ` ${plant.fields['Сорт_eng']}`
                          : ` ${plant.fields['Сорт_ru']}`
                        : ''
                    }`
                  : ''
              }
            />
          </a>
        ))}
      </div>
      <div ref={sentinelRef} />
      {isLoadingMore && (
        <div style={{display: 'flex', justifyContent: 'center', padding: '20px'}}>
          <Spin />
        </div>
      )}
      <PlantModal routeWhenClosed={parentRoute} />
    </div>
  )
}
